/**
 * StopOwenAudioOnRouteChange — Composant invisible
 * ================================================
 *
 * Monté UNE fois dans App.js à l'intérieur du BrowserRouter.
 * Appelle le hook qui stoppe toute voix Owen à chaque changement de route.
 */
import useStopOwenAudioOnRouteChange from '../hooks/useStopOwenAudioOnRouteChange';

export default function StopOwenAudioOnRouteChange() {
  useStopOwenAudioOnRouteChange();
  return null;
}
